import axios from "axios";
import router from "../routes/routes";
import config from "../config";
import TokenService from "./token.service";
import i18n from "@/i18n/index.js";

// Body-Felder (reason/status) und die axios-Response zusammen ablehnen: ein Teil der
// Aufrufer liest err.reason, der andere err.response.data.reason - beides soll gehen.
function buildError(error) {
  const body = error.response && error.response.data;
  const base = body && typeof body === "object" && !(body instanceof Blob) ? body : { status: "error" };
  return { ...base, response: error.response, message: error.message };
}

export default (props = { headers: {} }) => {
  let headers = {
    "cache-control": "no-cache",
    ...props.headers,
  };

  const accessToken = TokenService.getToken();
  if (accessToken && accessToken !== "") {
    headers.Authorization = accessToken;
  }

  const instance = axios.create({
    baseURL: config.api.url,
    headers: headers,
  });

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      // Netzwerkfehler/Timeout haben keine response - nicht im Interceptor crashen
      if (!error.response) {
        return Promise.reject(error.message);
      }

      // 401 = Token abgelaufen/ungueltig: zurueck zum Login. Das fruehere
      // Promise.resolve({data:{data:{}}}) hat leere Tabellen und falsche
      // "gespeichert"-Meldungen erzeugt, waehrend nichts gespeichert war.
      if (error.response.status === 401) {
        TokenService.clearToken();
        if (router.history.current.path !== "/login") {
          router.replace({ path: "/login", query: { returnUrl: router.history.current.path } });
        }
        return Promise.reject(buildError(error));
      }

      if (error.response.status === 403) {
        if (router.history.current.path !== "/login") {
          window.VueSingleton &&
            window.VueSingleton.$notify({
              timeout: 2500,
              message: i18n.t("permissionDeniedAction"),
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger",
            });
        }
        // 403 muss abgelehnt werden: sonst laeuft der then()-Zweig des Aufrufers weiter und
        // meldet "gespeichert"/"gebucht", obwohl der Server die Aktion verweigert hat.
        return Promise.reject(buildError(error));
      }

      return Promise.reject(buildError(error));
    }
  );

  return instance;
};
